import React from 'react';
import { Icon } from './Icon.js';
export const IconUser = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("circle", { cx: "10", cy: "6", r: "3", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("path", { d: "m4,15.393c1.225-2.033,3.454-3.393,6-3.393s4.775,1.36,6,3.393", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconUser.js.map